/**
 * Opens the CounterCool demo video from a link inside an FAQ answer.
 *
 * An answer is a `richtext` setting. Shopify allows only `<a href>` and a few
 * text tags there, so the answer cannot carry the `data-sources` attributes
 * that `assets/countercool-demo-video.js` reads.
 * https://shopify.dev/docs/storefronts/themes/architecture/settings/input-settings#richtext
 *
 * That file already binds a lightGallery overlay to the How it works button, so
 * this file forwards the click to that button and reuses the same overlay
 * instead of building a second one.
 *
 * The link points at the How it works section, so without JavaScript, and on a
 * page with no demo video, it stays a jump to where the demo button sits.
 */
(function () {
  const DEMO_SECTION_HASH = '#how-it-works';

  const links = document.querySelectorAll(`.aura-countercool-faq__answer a[href="${DEMO_SECTION_HASH}"]`);

  // Do not proceed if no answer links to the demo. The FAQ copy does not have
  // to mention it.
  if (!links.length) {
    return;
  }

  Array.from(links).forEach((link) => {
    link.addEventListener('click', (event) => {
      const button = document.querySelector('[aura-countercool-demo-video]');

      // Do not proceed without a button that already carries an overlay.
      // `countercool-demo-video.js` sets `galleryReady` only after it builds
      // one from a playable source, and the link then scrolls to the section.
      if (!button || !button.dataset.galleryReady) {
        return;
      }

      event.preventDefault();
      button.click();
    });
  });
})();
